const translations = {
    es: {
        parameters: "Parámetros",
        "field.interval_type": "Tipo de intervalo",
        "field.interval_type.description": "Tipo de funcionamiento del modo operativo.",
        "field.select": "Seleccionar...",

        "field.start_hour": "Hora de inicio",

        // h_start field
        h_start: "Hora de inicio",
        "h_start.name": "Hora de inicio",
        "field.start_hour.description": "Hora (en minutos) desde las 00:00 en la que comienza el modo operativo.",
        "field.start_hour.params": "min",

        // min_measure field
        "field.minutes_between_measures": "Minutos entre medidas",
        min_measure: "Minutos entre medidas",
        "min_measure.name": "Minutos entre medidas",
        "field.minutes_between_measures.description": "Tiempo en minutos entre cada medición.",
        "field.minutes_between_measures.params": "min",

        // min_measure_b field
        "field.minutes_between_measures_fl": "Minutos entre medidas FL",
        min_measure_b: "Minutos entre medidas FL",
        "min_measure_b.name": "Minutos entre medidas FL",
        "field.minutes_between_measures_fl.description": "Tiempo en minutos entre cada medición en rango largo.",
        "field.minutes_between_measures_fl.params": "Minutos FL",

        // num_measure field
        "field.collected_measures": "Medidas recogidas",
        num_measure: "Medidas recogidas",
        "num_measure.name": "Medidas recogidas",
        "field.collected_measures.description": "Número de medidas a recopilar en cada ciclo.",
        "field.collected_measures.params": "Cantidad",

        // num_pub field
        "field.number_to_send": "Número de publicaciones",
        num_pub: "Número de publicaciones",
        "num_pub.name": "Número de publicaciones",
        "field.number_to_send.description": "Cantidad de medidas que se enviarán en cada publicación.",
        "field.number_to_send.params": "Unidades",

        // interval_send field
        "field.publication_interval": "Intervalo de publicación",
        interval_send: "Intervalo de publicación",
        "interval_send.name": "Intervalo de publicación",
        "field.publication_interval.description": "Intervalo de tiempo entre publicaciones.",
        "field.publication_interval.params": "min",
    },
    en: {
        parameters: "Parameters",
        "field.interval_type": "Interval type",
        "field.interval_type.description": "Operation mode operation.",
        "field.select": "Select...",

        "field.start_hour": "Start hour",

        // h_start field
        h_start: "Start hour",
        "h_start.name": "Start hour",
        "field.start_hour.description": "Hour (in minutes) from 00:00 at which the operation mode starts.",
        "field.start_hour.params": "min",

        // min_measure field
        "field.minutes_between_measures.name": "Minutes between measures",
        min_measure: "Minutes between measures",
        "min_measure.name": "Minutes between measures",
        "field.minutes_between_measure.description": "Time in minutes between each measurement.",
        "field.minutes_between_measures.params": "min",

        // min_measure_b field
        "field.minutes_between_measures_fl": "Minutes between measures FL",
        min_measure_b: "Minutes between measures FL",
        "min_measure_b.name": "Minutes between measures FL",
        "field.minutes_between_measures_fl.description": "Time in minutes between each measurement in long range.",
        "field.minutes_between_measures_fl.params": "Minutes FL",

        // num_measure field
        "field.collected_measures.name": "Collected measures",
        num_measure: "Collected measures",
        "num_measure.name": "Collected measures",
        "field.collected_measures.description": "Number of measurements to collect in each cycle.",
        "field.collected_measures.params": "Amount",

        // num_pub field
        "field.number_to_send": "Number to send",
        num_pub: "Number to send",
        "num_pub.name": "Number to send",
        "field.number_to_send.description": "Number of measurements to send in each publication.",
        "field.number_to_send.params": "Unit",

        // interval_send field
        "field.publication_interval": "Publication interval",
        interval_send: "Publication interval",
        "interval_sned.name": "Publication interval",
        "field.publication_interval.description": "Time interval between publications.",
        "field.publication_interval.params": "min",
    },
};

export default translations;
